export default __webpack_public_path__ + "adb23b198449c944511ec237f464cfd2.svg";